export const downloadFromURL = (fileName, url) => fetch(url)
  .then((response) => {
    if (!response.ok) throw new Error('Network response was not ok');

    response.blob().then((blob) => downloadFromBlob(fileName, blob));
  });

export const downloadFromBlob = (fileName, blob) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(link.href);
};
